import React from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { ListGroup, ListGroupItem } from "components/bootstrap";
import ValueRenderer from "views/components/visualizations/OnClickPopover/ValueRenderer";
import getHoverSwatchColor from "views/components/visualizations/utils/getHoverSwatchColor";
import Popover from "components/common/Popover";
import PopoverTitle from "views/components/visualizations/OnClickPopover/PopoverTitle";
const StyledListGroup = styled(ListGroup)`
  max-height: 300px;
  overflow-y: auto;
  max-width: 450px;
`;
const ClickPointSelector = ({ clickPointsInRadius, onSelect, metricMapper }) => {
  const { t } = useTranslation("aggregation");
  return /* @__PURE__ */ React.createElement(Popover.Dropdown, { title: /* @__PURE__ */ React.createElement(PopoverTitle, null, t("vis_popover.data_points")) }, /* @__PURE__ */ React.createElement(StyledListGroup, null, clickPointsInRadius.map((clickPoint) => {
    const { value, metric } = metricMapper(clickPoint);
    const traceColor = getHoverSwatchColor(clickPoint);
    return /* @__PURE__ */ React.createElement(ListGroupItem, { onClick: () => onSelect(clickPoint), key: metric }, /* @__PURE__ */ React.createElement(ValueRenderer, { value, field: metric, traceColor }));
  })));
};
export default ClickPointSelector;
